import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Import fleet images
import fleetImage from '../assets/fleet/fleet.jpg';

// Van images
import van1 from '../assets/fleet/van/1.jpg';
import van2 from '../assets/fleet/van/2.jpg';
import van3 from '../assets/fleet/van/3.jpg';
import van4 from '../assets/fleet/van/4.jpg';

// Sprinter images
import sprinter1 from '../assets/fleet/sprinter/1.jpg';
import sprinter2 from '../assets/fleet/sprinter/2.jpg';
import sprinter3 from '../assets/fleet/sprinter/3.jpg';
import sprinter4 from '../assets/fleet/sprinter/4.jpg';

// Minivan images
import minivan1 from '../assets/fleet/minivan/1.jpg';
import minivan2 from '../assets/fleet/minivan/2.jpg';
import minivan3 from '../assets/fleet/minivan/3.jpg';
import minivan4 from '../assets/fleet/minivan/4.jpg';

// Minibus images
import minibus1 from '../assets/fleet/minibus/1.jpg';
import minibus2 from '../assets/fleet/minibus/2.jpg';
import minibus3 from '../assets/fleet/minibus/3.jpg';
import minibus4 from '../assets/fleet/minibus/4.jpg';

// Minicoach images
import minicoach1 from '../assets/fleet/minicoach/1.jpg';
import minicoach2 from '../assets/fleet/minicoach/2.jpg';
import minicoach3 from '../assets/fleet/minicoach/3.jpg';
import minicoach4 from '../assets/fleet/minicoach/4.jpg';
import minicoach5 from '../assets/fleet/minicoach/5.jpg';

interface FleetVehicle {
  id: string;
  image: string;
  title: string;
  capacity: string;
  description: string;
}

interface FleetCategory {
  id: string;
  name: string;
  vehicles: FleetVehicle[];
}

interface FleetCarouselProps {
  className?: string;
}

const FleetCarousel: React.FC<FleetCarouselProps> = ({ className = '' }) => {
  const { t } = useTranslation();
  const [currentSlides, setCurrentSlides] = useState<number[]>([0, 0, 0, 0, 0]);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const fleetCategories: FleetCategory[] = [
    {
      id: 'van',
      name: t('fleet_van_title'),
      vehicles: [
        {
          id: 'van-1',
          image: van1,
          title: t('fleet_van_title'),
          capacity: t('fleet_van_capacity'),
          description: t('fleet_van_description')
        },
        {
          id: 'van-2',
          image: van2,
          title: t('fleet_van_title'),
          capacity: t('fleet_van_capacity'),
          description: t('fleet_van_description')
        },
        {
          id: 'van-3',
          image: van3,
          title: t('fleet_van_title'),
          capacity: t('fleet_van_capacity'),
          description: t('fleet_van_description')
        },
        {
          id: 'van-4',
          image: van4,
          title: t('fleet_van_title'),
          capacity: t('fleet_van_capacity'),
          description: t('fleet_van_description')
        }
      ]
    },
    {
      id: 'sprinter',
      name: t('fleet_sprinter_carousel_title'),
      vehicles: [
        {
          id: 'sprinter-1',
          image: sprinter1,
          title: t('fleet_sprinter_carousel_title'),
          capacity: t('fleet_sprinter_carousel_capacity'),
          description: t('fleet_sprinter_carousel_description')
        },
        {
          id: 'sprinter-2',
          image: sprinter2,
          title: t('fleet_sprinter_carousel_title'),
          capacity: t('fleet_sprinter_carousel_capacity'),
          description: t('fleet_sprinter_carousel_description')
        },
        {
          id: 'sprinter-3',
          image: sprinter3,
          title: t('fleet_sprinter_carousel_title'),
          capacity: t('fleet_sprinter_carousel_capacity'),
          description: t('fleet_sprinter_carousel_description')
        },
        {
          id: 'sprinter-4',
          image: sprinter4,
          title: t('fleet_sprinter_carousel_title'),
          capacity: t('fleet_sprinter_carousel_capacity'),
          description: t('fleet_sprinter_carousel_description')
        }
      ]
    },
    {
      id: 'minivan',
      name: t('fleet_minivan_title'),
      vehicles: [
        {
          id: 'minivan-1',
          image: minivan1,
          title: t('fleet_minivan_title'),
          capacity: t('fleet_minivan_capacity'),
          description: t('fleet_minivan_description')
        },
        {
          id: 'minivan-2',
          image: minivan2,
          title: t('fleet_minivan_title'),
          capacity: t('fleet_minivan_capacity'),
          description: t('fleet_minivan_description')
        },
        {
          id: 'minivan-3',
          image: minivan3,
          title: t('fleet_minivan_title'),
          capacity: t('fleet_minivan_capacity'),
          description: t('fleet_minivan_description')
        },
        {
          id: 'minivan-4',
          image: minivan4,
          title: t('fleet_minivan_title'),
          capacity: t('fleet_minivan_capacity'),
          description: t('fleet_minivan_description')
        }
      ]
    },
    {
      id: 'minibus',
      name: t('fleet_minibus_carousel_title'),
      vehicles: [
        {
          id: 'minibus-1',
          image: minibus1,
          title: t('fleet_minibus_carousel_title'),
          capacity: t('fleet_minibus_carousel_capacity'),
          description: t('fleet_minibus_carousel_description')
        },
        {
          id: 'minibus-2',
          image: minibus2,
          title: t('fleet_minibus_carousel_title'),
          capacity: t('fleet_minibus_carousel_capacity'),
          description: t('fleet_minibus_carousel_description')
        },
        {
          id: 'minibus-3',
          image: minibus3,
          title: t('fleet_minibus_carousel_title'),
          capacity: t('fleet_minibus_carousel_capacity'),
          description: t('fleet_minibus_carousel_description')
        },
        {
          id: 'minibus-4',
          image: minibus4,
          title: t('fleet_minibus_carousel_title'),
          capacity: t('fleet_minibus_carousel_capacity'),
          description: t('fleet_minibus_carousel_description')
        }
      ]
    },
    {
      id: 'minicoach',
      name: t('fleet_minicoach_title'),
      vehicles: [
        {
          id: 'minicoach-1',
          image: minicoach1,
          title: t('fleet_minicoach_title'),
          capacity: t('fleet_minicoach_capacity'),
          description: t('fleet_minicoach_description')
        },
        {
          id: 'minicoach-2',
          image: minicoach2,
          title: t('fleet_minicoach_title'),
          capacity: t('fleet_minicoach_capacity'),
          description: t('fleet_minicoach_description')
        },
        {
          id: 'minicoach-3',
          image: minicoach3,
          title: t('fleet_minicoach_title'),
          capacity: t('fleet_minicoach_capacity'),
          description: t('fleet_minicoach_description')
        },
        {
          id: 'minicoach-4',
          image: minicoach4,
          title: t('fleet_minicoach_title'),
          capacity: t('fleet_minicoach_capacity'),
          description: t('fleet_minicoach_description')
        },
        {
          id: 'minicoach-5',
          image: minicoach5,
          title: t('fleet_minicoach_title'),
          capacity: t('fleet_minicoach_capacity'),
          description: t('fleet_minicoach_description')
        }
      ]
    }
  ];

  const nextSlide = (categoryIndex: number) => {
    setCurrentSlides(prev => {
      const newSlides = [...prev];
      newSlides[categoryIndex] = (newSlides[categoryIndex] + 1) % fleetCategories[categoryIndex].vehicles.length;
      return newSlides;
    });
  };

  const prevSlide = (categoryIndex: number) => {
    setCurrentSlides(prev => {
      const newSlides = [...prev];
      newSlides[categoryIndex] = (newSlides[categoryIndex] - 1 + fleetCategories[categoryIndex].vehicles.length) % fleetCategories[categoryIndex].vehicles.length;
      return newSlides;
    });
  };

  const goToSlide = (categoryIndex: number, slideIndex: number) => {
    setCurrentSlides(prev => {
      const newSlides = [...prev];
      newSlides[categoryIndex] = slideIndex;
      return newSlides;
    });
  };

  // Touch handlers for swipe functionality
  const minSwipeDistance = 50;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = (categoryIndex: number) => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide(categoryIndex);
    } else if (isRightSwipe) {
      prevSlide(categoryIndex);
    }
  };

  return (
    <div className={`fleet-section ${className}`}>
      <style>
        {`
          .fleet-section {
            background: #fff;
            width: 100%;
            padding: 4rem 0;
          }

          .fleet-title {
            font-size: 2.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 1rem;
            text-align: left;
          }

          .fleet-description {
            font-size: 1.1rem;
            color: #6b7280;
            margin-bottom: 3rem;
            text-align: left;
            max-width: 800px;
          }

          .fleet-hero-image-container {
            max-width: 1200px;
            margin: 0 auto 3rem auto;
            padding: 0 2rem;
            box-sizing: border-box;
          }

          .fleet-hero-image {
            width: 100%;
            height: 400px;
            object-fit: cover;
            object-position: center;
            border-radius: 24px;
            display: block;
          }

          .fleet-cards-container {
            display: flex;
            flex-direction: column;
            gap: 3rem;
          }

          .fleet-card-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 2rem;
            position: relative;
          }

          .fleet-card {
            display: flex;
            background: #fff;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
            height: 400px;
            position: relative;
          }

          .fleet-card-image-section {
            flex: 0 0 60%;
            position: relative;
            background: #f8f9fa;
          }

          .fleet-carousel-wrapper {
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;
          }

          .fleet-carousel-track {
            display: flex;
            height: 100%;
            transition: transform 0.5s ease-in-out;
          }

          .fleet-carousel-slide {
            min-width: 100%;
            height: 100%;
            position: relative;
          }

          .fleet-carousel-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }

          .fleet-carousel-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 193, 7, 0.9);
            border: none;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            z-index: 3;
          }

          .fleet-carousel-nav:hover {
            background: rgba(255, 193, 7, 1);
            transform: translateY(-50%) scale(1.1);
          }

          .fleet-carousel-nav svg {
            color: #1f2937;
            width: 20px;
            height: 20px;
          }

          .fleet-carousel-prev {
            left: 16px;
          }

          .fleet-carousel-next {
            right: 16px;
          }

          .fleet-carousel-dots {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 8px;
            z-index: 3;
          }

          .fleet-carousel-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.6);
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .fleet-carousel-dot.active {
            background: #ffc107;
            transform: scale(1.2);
          }

          .fleet-carousel-dot:hover {
            background: rgba(255, 255, 255, 0.8);
          }

          .fleet-card-text-section {
            flex: 0 0 40%;
            background: #2d3748;
            padding: 2.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: white;
          }

          .fleet-card-title {
            font-size: 2rem;
            font-weight: 700;
            color: white;
            margin: 1rem 0 0.5rem 0;
            position: relative;
          }

          .fleet-card-title::after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 60px;
            height: 3px;
            background: #ffc107;
          }

          .fleet-card-capacity {
            font-size: 1.1rem;
            color: #e2e8f0;
            margin: 1.5rem 0 2rem 0;
          }

          .fleet-card-description {
            font-size: 1rem;
            line-height: 1.6;
            color: #e2e8f0;
            white-space: pre-line;
          }

          /* Mobile Responsive */
          @media (max-width: 768px) {
            .fleet-section {
              padding: 2rem 0;
            }

            .fleet-hero-image-container {
              margin-bottom: 2rem;
            }

            .fleet-hero-image {
              height: 250px;
              border-radius: 12px;
            }

            .fleet-title {
              font-size: 2rem;
              padding: 0 1rem;
            }

            .fleet-description {
              padding: 0 1rem;
              margin-bottom: 2rem;
            }

            .fleet-cards-container {
              padding: 0 1rem;
              gap: 0.5rem;
            }

            .fleet-card-container {
              padding: 0;
              margin: 0;
              max-width: none;
            }

            .fleet-card {
              flex-direction: column;
              height: auto;
              border-radius: 0;
              box-shadow: none;
              margin: 0 0.5rem;
              border-radius: 16px;
              overflow: hidden;
            }

            .fleet-card-image-section {
              flex: none;
              height: 280px;
              position: relative;
            }

            .fleet-carousel-wrapper {
              border-radius: 16px 16px 0 0;
              overflow: hidden;
            }

            .fleet-carousel-nav {
              width: 28px;
              height: 28px;
              background: rgba(0, 0, 0, 0.3);
              backdrop-filter: blur(4px);
            }

            .fleet-carousel-nav:hover {
              background: rgba(0, 0, 0, 0.5);
              transform: translateY(-50%);
            }

            .fleet-carousel-nav svg {
              color: white;
              width: 14px;
              height: 14px;
            }

            .fleet-carousel-prev {
              left: 8px;
            }

            .fleet-carousel-next {
              right: 8px;
            }

            .fleet-carousel-dots {
              bottom: 12px;
              left: 50%;
              transform: translateX(-50%);
              gap: 3px;
            }

            .fleet-section .fleet-card .fleet-card-image-section .fleet-carousel-wrapper .fleet-carousel-dots .fleet-carousel-dot {
              width: 0.375rem !important;
              height: 0.375rem !important;
              min-width: 0.375rem !important;
              min-height: 0.375rem !important;
              max-width: 0.375rem !important;
              max-height: 0.375rem !important;
              background: rgba(255, 255, 255, 0.6) !important;
              padding: 0 !important;
              margin: 0 !important;
              border: none !important;
              border-radius: 50% !important;
              box-sizing: border-box !important;
              transform: none !important;
            }

            .fleet-section .fleet-card .fleet-card-image-section .fleet-carousel-wrapper .fleet-carousel-dots .fleet-carousel-dot.active {
              background: #ffc107 !important;
              transform: scale(1.3) !important;
              width: 0.375rem !important;
              height: 0.375rem !important;
            }

            .fleet-card-text-section {
              flex: none;
              padding: 1.5rem;
              border-radius: 0 0 16px 16px;
            }

            .fleet-card-title {
              font-size: 1.5rem;
            }

            .fleet-card-capacity {
              font-size: 1rem;
              margin: 1rem 0 1.5rem 0;
            }

            .fleet-card-description {
              font-size: 0.9rem;
              line-height: 1.5;
            }
          }

          @media (max-width: 480px) {
            .fleet-section {
              padding: 1.5rem 0;
            }

            .fleet-hero-image-container {
              margin-bottom: 1.5rem;
            }

            .fleet-hero-image {
              height: 200px;
              border-radius: 8px;
            }

            .fleet-title {
              font-size: 1.75rem;
            }

            .fleet-cards-container {
              margin: 0;
              padding: 0;
            }

            .fleet-card {
              margin: 0 0.25rem;
              border-radius: 12px;
            }

            .fleet-card-image-section {
              height: 240px;
            }

            .fleet-carousel-wrapper {
              border-radius: 12px 12px 0 0;
            }

            .fleet-carousel-nav {
              width: 24px;
              height: 24px;
              background: rgba(0, 0, 0, 0.25);
            }

            .fleet-carousel-nav svg {
              width: 12px;
              height: 12px;
            }

            .fleet-carousel-prev {
              left: 6px;
            }

            .fleet-carousel-next {
              right: 6px;
            }

            .fleet-carousel-dots {
              bottom: 12px;
              left: 50%;
              transform: translateX(-50%);
              gap: 3px;
            }

            .fleet-section .fleet-card .fleet-card-image-section .fleet-carousel-wrapper .fleet-carousel-dots .fleet-carousel-dot {
              width: 0.375rem !important;
              height: 0.375rem !important;
              min-width: 0.375rem !important;
              min-height: 0.375rem !important;
              max-width: 0.375rem !important;
              max-height: 0.375rem !important;
              background: rgba(255, 255, 255, 0.6) !important;
              padding: 0 !important;
              margin: 0 !important;
              border: none !important;
              border-radius: 50% !important;
              box-sizing: border-box !important;
              transform: none !important;
            }

            .fleet-section .fleet-card .fleet-card-image-section .fleet-carousel-wrapper .fleet-carousel-dots .fleet-carousel-dot.active {
              background: #ffc107 !important;
              transform: scale(1.3) !important;
              width: 0.375rem !important;
              height: 0.375rem !important;
            }

            .fleet-card-text-section {
              padding: 1.25rem;
              border-radius: 0 0 12px 12px;
            }

            .fleet-card-title {
              font-size: 1.25rem;
            }

            .fleet-card-capacity {
              font-size: 0.9rem;
            }

            .fleet-card-description {
              font-size: 0.85rem;
            }
          }
        `}
      </style>

      <div className="container">
        {/* Fleet Title */}
        <h2 className="fleet-title">{t('fleet_title')}</h2>

        <p className="fleet-description">
          {t('fleet_description')}
        </p>

        {/* Fleet Hero Image - moved below title */}
        <div className="fleet-hero-image-container">
          <img
            src={fleetImage}
            alt="Our Fleet"
            className="fleet-hero-image"
          />
        </div>

        {/* Fleet Cards Container */}
        <div className="fleet-cards-container">
          {fleetCategories.map((category, categoryIndex) => (
            <div key={category.id} className="fleet-card-container">
              <div className="fleet-card">
                {/* Left Side - Image Carousel (60%) */}
                <div className="fleet-card-image-section">
                  <div
                    className="fleet-carousel-wrapper"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={() => onTouchEnd(categoryIndex)}
                  >
                    <div
                      className="fleet-carousel-track"
                      style={{ transform: `translateX(-${currentSlides[categoryIndex] * 100}%)` }}
                    >
                      {category.vehicles.map((vehicle, index) => (
                        <div key={vehicle.id} className="fleet-carousel-slide">
                          <img
                            src={vehicle.image}
                            alt={vehicle.title}
                            className="fleet-carousel-image"
                          />
                        </div>
                      ))}
                    </div>

                    {/* Navigation Arrows */}
                    <button
                      className="fleet-carousel-nav fleet-carousel-prev"
                      onClick={(e) => {
                        e.stopPropagation();
                        prevSlide(categoryIndex);
                      }}
                      aria-label="Previous image"
                    >
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    <button
                      className="fleet-carousel-nav fleet-carousel-next"
                      onClick={(e) => {
                        e.stopPropagation();
                        nextSlide(categoryIndex);
                      }}
                      aria-label="Next image"
                    >
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    {/* Dots Indicator */}
                    <div className="fleet-carousel-dots">
                      {category.vehicles.map((_, index) => (
                        <button
                          key={index}
                          className={`fleet-carousel-dot ${index === currentSlides[categoryIndex] ? 'active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            goToSlide(categoryIndex, index);
                          }}
                          aria-label={`Go to slide ${index + 1}`}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right Side - Text Section (40%) */}
                <div className="fleet-card-text-section">
                  <h3 className="fleet-card-title">{category.vehicles[currentSlides[categoryIndex]].title}</h3>
                  <p className="fleet-card-capacity">{category.vehicles[currentSlides[categoryIndex]].capacity}</p>
                  <p className="fleet-card-description">{category.vehicles[currentSlides[categoryIndex]].description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FleetCarousel; 